"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function listStringify(a) {
    return JSON.stringify(a.map(v => v.toString()));
}
exports.default = listStringify;
